import React, { useState, useEffect } from 'react';

const BACKEND = process.env.REACT_APP_BACKEND_URL || 'https://nethajiprime-backend.onrender.com';

const TABS = [
  { key: 'india', label: '🇮🇳 India' },
  { key: 'us', label: '🇺🇸 USA' },
  { key: 'forex', label: '💱 Forex' },
];

// Matches the React Native StockMarketScreen forex list (rates are vs INR).
const FOREX_PAIRS = [
  { code: 'USD', flag: '🇺🇸', label: 'US Dollar' },
  { code: 'GBP', flag: '🇬🇧', label: 'British Pound' },
  { code: 'EUR', flag: '🇪🇺', label: 'Euro' },
  { code: 'SGD', flag: '🇸🇬', label: 'Singapore Dollar' },
  { code: 'AED', flag: '🇦🇪', label: 'UAE Dirham' },
  { code: 'CAD', flag: '🇨🇦', label: 'Canadian Dollar' },
  { code: 'AUD', flag: '🇦🇺', label: 'Australian Dollar' },
  { code: 'MYR', flag: '🇲🇾', label: 'Malaysian Ringgit' },
  { code: 'JPY', flag: '🇯🇵', label: 'Japanese Yen' },
  { code: 'CHF', flag: '🇨🇭', label: 'Swiss Franc' },
];

function StockCard({ s, currency }) {
  const sym = currency === 'USD' ? '$' : 'Rs.';
  return (
    <div style={{ background: s.isUp ? 'rgba(0,200,100,0.08)' : 'rgba(255,50,50,0.08)', border: '1px solid ' + (s.isUp ? 'rgba(0,200,100,0.3)' : 'rgba(255,50,50,0.3)'), borderRadius: 10, padding: '12px', textAlign: 'center' }}>
      <div style={{ fontSize: 20, marginBottom: 4 }}>{s.emoji || '📊'}</div>
      <div style={{ color: '#fff', fontWeight: 700, fontSize: 12, marginBottom: 2 }}>{s.name}</div>
      <div style={{ color: s.isUp ? '#00cc66' : '#ff4444', fontWeight: 900, fontSize: 16 }}>
        {s.price != null ? sym + Number(s.price).toLocaleString('en-IN') : 'N/A'}
      </div>
      <div style={{ color: s.isUp ? '#00cc66' : '#ff4444', fontSize: 11, marginTop: 2 }}>
        {s.isUp ? '▲' : '▼'} {Math.abs(s.changePct || 0).toFixed(2)}%
      </div>
    </div>
  );
}

function ForexCard({ pair, rate }) {
  return (
    <div style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,215,0,0.2)', borderRadius: 10, padding: '12px', textAlign: 'center' }}>
      <div style={{ fontSize: 20, marginBottom: 4 }}>{pair.flag}</div>
      <div style={{ color: '#fff', fontWeight: 700, fontSize: 12 }}>{pair.code}</div>
      <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 9, marginBottom: 2 }}>{pair.label}</div>
      <div style={{ color: '#FFD700', fontWeight: 900, fontSize: 15 }}>{rate != null ? 'Rs.' + Number(rate).toFixed(2) : 'N/A'}</div>
    </div>
  );
}

export default function StockMarketLive() {
  const [tab, setTab] = useState('india');
  const [indiaStocks, setIndiaStocks] = useState([]);
  const [usStocks, setUsStocks] = useState([]);
  const [forexRates, setForexRates] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState(null);

  const fetchAll = async () => {
    setLoading(true);
    await Promise.all([
      fetch(BACKEND + '/api/stocks').then(r => r.json()).then(d => setIndiaStocks(d.stocks || [])).catch(() => {}),
      fetch(BACKEND + '/api/stocks/us').then(r => r.json()).then(d => setUsStocks(d.stocks || [])).catch(() => {}),
      fetch(BACKEND + '/api/exchange-rates').then(r => r.json()).then(d => setForexRates(d.rates || d)).catch(() => {}),
    ]);
    setLastUpdated(new Date().toLocaleTimeString('en-IN'));
    setLoading(false);
  };

  useEffect(() => {
    fetchAll();
    const interval = setInterval(fetchAll, 60000);
    return () => clearInterval(interval);
  }, []);

  const grid = { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 10 };
  const empty = { color: 'rgba(255,255,255,0.4)', padding: 12, fontSize: 12 };
  const tabBtn = (active) => ({ padding: '6px 16px', borderRadius: 20, border: active ? 'none' : '1px solid rgba(255,215,0,0.3)', background: active ? '#FFD700' : 'transparent', color: active ? '#000' : '#FFD700', fontWeight: 700, cursor: 'pointer', fontSize: 12 });

  return (
    <div style={{ padding: '16px', background: 'rgba(0,0,0,0.3)', borderRadius: 12, margin: '16px 0' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
        <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 16, color: '#FFD700', letterSpacing: 3 }}>📈 LIVE MARKETS</div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          {lastUpdated && <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: 10 }}>Updated: {lastUpdated}</span>}
          <button onClick={fetchAll} style={{ background: 'rgba(255,215,0,0.1)', border: '1px solid rgba(255,215,0,0.3)', color: '#FFD700', borderRadius: 6, padding: '4px 10px', fontSize: 10, cursor: 'pointer' }}>↻ Refresh</button>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 14, flexWrap: 'wrap' }}>
        {TABS.map(t => <button key={t.key} onClick={() => setTab(t.key)} style={tabBtn(tab === t.key)}>{t.label}</button>)}
      </div>

      {loading && indiaStocks.length === 0 && usStocks.length === 0 && !forexRates ? (
        <div style={{ textAlign: 'center', padding: 20, color: '#FFD700' }}>Loading market data...</div>
      ) : (
        <>
          {tab === 'india' && (indiaStocks.length
            ? <div style={grid}>{indiaStocks.map((s, i) => <StockCard key={i} s={s} currency="INR" />)}</div>
            : <div style={empty}>No India market data available.</div>)}
          {tab === 'us' && (usStocks.length
            ? <div style={grid}>{usStocks.map((s, i) => <StockCard key={i} s={s} currency="USD" />)}</div>
            : <div style={empty}>No US market data available.</div>)}
          {tab === 'forex' && (forexRates
            ? <div style={grid}>{FOREX_PAIRS.map((p, i) => <ForexCard key={i} pair={p} rate={forexRates[p.code]} />)}</div>
            : <div style={empty}>No forex data available.</div>)}
        </>
      )}

      <div style={{ color: 'rgba(255,255,255,0.2)', fontSize: 10, textAlign: 'center', marginTop: 12 }}>
        Data from Yahoo Finance / exchangerate-api. For informational purposes only. Not financial advice.
      </div>
    </div>
  );
}
